<template>
    <div class="content1-box">
       <div class="title">
           <img src="@/assets/home/intergral-title-icon2.png" alt="">
           <div class="text">高新区企业创新积分榜</div>
           <img src="@/assets/home/intergral-title-icon1.png" alt="">
       </div>
       <div class="content-container">
           <div class="tab-box">
               <div class="item" :class="tabsId == '1' ? 'item-active': ''" @click="tabsChange('1')">种子期企业</div>
               <div class="item" :class="tabsId == '2' ? 'item-active': ''" @click="tabsChange('2')">初创期企业</div>
               <div class="item" :class="tabsId == '3' ? 'item-active': ''" @click="tabsChange('3')">成长期企业</div>
               <div class="item" :class="tabsId == '4' ? 'item-active': ''" @click="tabsChange('4')">成熟期企业</div>
           </div>
           <div class="tongji-box">
               <div class="top-item-box">
                  <div class="item" v-for="(item,index) in showData.slice(0,3)" :key="index">
                      <div><span>{{ item.totalScore }} </span>分</div>
                      <div class="name">{{ ellipsis(item.companyName) }}</div>
                  </div>
               </div>
               <div class="list-box">
                   <div class="header">
                       <div class="tit">排行</div>
                       <div class="tit">企业名称</div>
                       <div class="tit">积分年度</div>
                       <div class="tit">分数</div>
                   </div>
                   <div class="body">
                       <div class="tr" v-for="(item,index) in showData" :key="index">
                           <div class="tit">
                               <img class="tit-img" v-if="index == 0" src="../../../assets/home/first-icon.png" alt="">
                               <img class="tit-img"  v-if="index == 1" src="../../../assets/home/second-icon.png" alt="">
                               <img class="tit-img"  v-if="index == 2" src="../../../assets/home/three-icon.png" alt="">
                               <div v-if="index > 2">{{ index + 1}}</div>
                           </div>
                           <div class="tit">{{ ellipsis(item.companyName) }}</div>
                           <div class="tit">{{item.year}}年</div>
                           <div class="tit">{{ item.totalScore }}</div>
                       </div>
                   </div>
               </div>
           </div>
       </div>
        <div class="cpqyzl">
            <div class="title-1">参评企业总览</div>
            <div class="item-box">
                <div class="item">
                    <div class="name">{{getData[0].name}}</div>
                    <div class="num"><span>{{getData[0].value}}</span>家</div>
                    <div class="text">营业收入规模：</div>
                    <div class="text">0万元（含）-100万元</div>
                </div>
                <div class="item">
                    <div class="name">{{getData[1].name}}</div>
                    <div class="num"><span>{{getData[1].value}}</span>家</div>
                    <div class="text">营业收入规模：</div>
                    <div class="text">100万(含)-500万</div>
                </div>
                <div class="item">
                    <div class="name">{{getData[2].name}}</div>
                    <div class="num"><span>{{getData[2].value}}</span>家</div>
                    <div class="text">营业收入规模：</div>
                    <div class="text">500万(含)-2000万</div>
                </div>
                <div class="item">
                    <div class="name">{{getData[3].name}}</div>
                    <div class="num"><span>{{getData[3].value}}</span>家</div>
                    <div class="text">营业收入规模：</div>
                    <div class="text">2000万(含)以上</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {companyPointsSystem} from "@/api/integral";
export default {
	name: "index",
	data() {
		return {
            tabsId:'1',
            dataA:[],
            dataB:[],
            dataC:[],
            dataD:[],
            getData:{},
            showData:[]
		}
	},
	mounted() {
        this.getBannerList()
        this.getBannerList1()
	},
	methods: {
        getBannerList() {
            this.getAction({
                url: companyPointsSystem.getWebType,
            }).then(res => {
                this.dataA = res.A
                this.dataB = res.B
                this.dataC = res.C
                this.dataD = res.D
                this.showData = res.A
            })
        },
        getBannerList1() {
            this.getAction({
                url: companyPointsSystem.getCompanyData,
            }).then(res => {
                this.getData = res
            })
        },
        ellipsis(value){
            if (!value) return '';
            if (value.length > 12) {
                return value.slice(0,12) + '...'
            }
            return value
        },
        tabsChange(e){
            this.tabsId = e
            if(e == '1'){
                this.showData = this.dataA
            }else if(e == '2'){
                this.showData = this.dataB
            }else if(e == '3'){
                this.showData = this.dataC
            }else{
                this.showData = this.dataD
            }
            console.log(this.showData,'ddddddddd')

        }

	}
}
</script>

<style scoped lang="less">
.content1-box{
    width: 1200px;
    margin:40px auto 0 auto;
    border-radius: 2px;
    .cpqyzl{
        background: url("../../../assets/home/cpqyzl-bj.png");
        background-size: 100% 100%;
        padding:10px 30px 30px 30px;
        .item-box{
            display: flex;
            justify-content: space-between;
            margin:20px 0 0 0;
            .item{
                text-align: center;
                width: 25%;
                border-right: 1px solid #E5EEFF;
                color: #333333;
                .num{
                    span{
                        font-weight: bold;
                        font-size: 50px;
                        color: #0059B5;
                        margin-right: 4px;
                    }
                }
                .text{
                    font-weight: 400;
                    font-size: 14px;
                    color: #999999;
                    line-height: 24px;
                }
            }
            .item:last-child{
                border:none;
            }
        }
        .title-1{
            font-weight: bold;
            font-size: 20px;
            color: #333333;
            line-height: 50px;
            position: relative;
            padding-left: 15px;
        }
        .title-1:before{
            content:'';
            display:block;
            position: absolute;
            width: 6px;
            height: 20px;
            background: linear-gradient(0deg, #3F67FF, #55A2F9);
            border-radius: 3px;
            top:15px;
            left:0;
        }
    }
    .content-container{
        .tab-box{
            display: flex;
            justify-content: center;
            .item{
                background: url("../../../assets/home/tab-title-bj.png");
                background-size: 100% 100%;
                padding:14px 40px;
                margin:0 20px 0 0;
                font-size: 20px;
                color: #0F2555;
                cursor: pointer;
            }
            .item-active{
                background: url("../../../assets/home/tab-title-bj-selected.png");
                background-size: 100% 100%;
                color:#fff;
                font-weight: bold;
            }
        }
        .tongji-box{
            background: #fff;
            margin-bottom: 20px;
            padding-bottom: 20px;
            .top-item-box{
                display: flex;
                justify-content: space-between;
                padding:60px 30px 40px 30px;
                margin-top:-30px;
                .item{
                    width: 32%;
                    background: url("../../../assets/home/number01.png");
                    background-size: 100% 100%;
                    text-align: center;
                    padding:30px 40px;
                    font-weight: 400;
                    font-size: 16px;
                    color: #fff;
                    span{
                        font-size:50px;
                    }
                }
                .item:nth-child(2){
                    background: url("../../../assets/home/number02.png");
                    background-size: 100% 100%;
                }
                .item:nth-child(3){
                    background: url("../../../assets/home/number03.png");
                    background-size: 100% 100%;
                }
            }
            .list-box{
                .header{
                    display: flex;
                    justify-content: space-between;
                    margin:0 30px;
                    background: #E5EEFF;
                    .tit{
                        width: 20%;
                        text-align: center;
                        font-weight: bold;
                        font-size: 20px;
                        color: #0F2555;
                        line-height: 50px;
                    }
                }
                .body{
                    margin:0 30px;
                    .tr{
                        border-bottom: 1px solid #F7F8FA;

                        display: flex;
                        justify-content: space-between;
                        .tit{
                            width: 20%;
                            text-align: center;
                            font-weight: 400;
                            font-size: 16px;
                            color: #333333;
                            line-height: 50px;
                        }
                        .tit-img{
                            width: 30px;
                            height: 35px;
                            display: block;
                            margin:6px auto 0 auto;
                        }
                    }
                    .tr:last-child{
                        border: none;
                    }
                }
            }
        }
    }
    .title{
        display: flex;
        justify-content: space-between;
        font-weight: bold;
        font-size: 40px;
        color: #0F2555;
        line-height: 24px;
        padding:40px 0;
        img{
             width: 380px;
             height: 17px;
        }
    }
}
</style>
